export const FRANCHISE_DAYS = 10;
